import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommercialsOverviewComponent } from './commercials-overview.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { AppPipesModule } from 'app/pipes/app-pipes.module';
import { NgImageSliderModule } from 'ng-image-slider-v16';
// import { AgmCoreModule } from '@agm/core';
import { GoogleMapsModule } from '@angular/google-maps'
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';


@NgModule({
  declarations: [CommercialsOverviewComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    AppPipesModule,
    NgImageSliderModule,
    MatProgressSpinnerModule,
    RouterModule, 
    MatDatepickerModule,
    GoogleMapsModule,
    // AgmCoreModule.forRoot({
    //   apiKey: ''
    // })
  ],
  exports: [CommercialsOverviewComponent]
})
export class CommercialsOverviewModule { }
